export type IncidentKind = 'outage' | 'maintenance';

export type IncidentStatus =
  | 'investigating'
  | 'identified'
  | 'monitoring'
  | 'resolved'
  | 'scheduled'
  | 'in_progress'
  | 'complete';

export interface IncidentAffectedComponent {
  repoKey: string;
  suiteKey: string;
  network: 'mainnet' | 'testnet';
}

export interface IncidentUpdate {
  id: number;
  status: IncidentStatus;
  body: string;
  createdAt: string;
}

export interface Incident {
  id: number;
  kind: IncidentKind;
  title: string;
  status: IncidentStatus;
  affectedComponents: IncidentAffectedComponent[];
  scheduledFor: string | null;
  startedAt: string;
  resolvedAt: string | null;
  durationSec: number | null;
  updates: IncidentUpdate[];
}

export interface IncidentMonthGroup {
  month: string; // YYYY-MM
  incidents: Incident[];
}

export interface IncidentsResponse {
  incidents: Incident[];
  groupedByMonth: IncidentMonthGroup[];
  days: number;
}

async function fetchJson<T>(url: string): Promise<T> {
  const response = await fetch(url, {
    headers: { Accept: 'application/json' },
  });
  if (!response.ok) {
    throw new Error(`Request to ${url} failed (${response.status})`);
  }
  return (await response.json()) as T;
}

export async function fetchIncidents(days = 90): Promise<IncidentsResponse> {
  return fetchJson<IncidentsResponse>(`/api/v1/incidents?days=${days}`);
}
